// extracted by mini-css-extract-plugin
module.exports = {"mCurated":"kv","flipped":"lv","mainContentContainer":"mv","cta":"nv","mainContentCtaDefault":"ov","disabled":"pv","mainContentCtaWhite":"qv"};